/* SQ1 PDP — ported from product-candy-bar.html, wired to real Shopify data.
   Pricing state machine (variant + plan + frequency), gallery swap, grind
   line-item property, sticky offer bar, sub-aware cross-sell chips. */
(function () {
  if (window.__sq1Pdp) return;
  window.__sq1Pdp = true;
  var d = document;
  var dataEl = d.getElementById('sq1-pdp-data');
  if (!dataEl) return;
  var cfg = JSON.parse(dataEl.textContent);
  var state = { variantId: cfg.initial_variant, plan: cfg.has_plans ? 'sub' : 'one', planId: cfg.default_plan };

  function variant() {
    for (var i = 0; i < cfg.variants.length; i++) if (cfg.variants[i].id === state.variantId) return cfg.variants[i];
    return cfg.variants[0];
  }
  // cents -> "$24" / "$20.40" (design money())
  function money(cents) {
    var n = cents / 100;
    return '$' + (Math.round(n * 100) % 100 === 0 ? n.toFixed(0) : n.toFixed(2));
  }
  function cupsOf(v) {
    var m = v.title.match(/(\d+(?:\.\d+)?)\s*oz/i);
    if (m) return Math.round(parseFloat(m[1]) * 1.5);
    m = v.title.match(/(\d+(?:\.\d+)?)\s*lb/i);
    if (m) return Math.round(parseFloat(m[1]) * 16 * 1.5);
    return 18;
  }
  function percup(cents, cups) {
    var per = cents / 100 / cups;
    if (per < 0.90) return 'under 90¢ a cup';
    return 'about $' + per.toFixed(2) + ' a cup';
  }
  function teaCupsOf(v) {
    var m = v.title.match(/(\d+(?:\.\d+)?)\s*oz/i);
    if (m) return Math.round(parseFloat(m[1]) * 28 / 2.5);
    return 0;
  }
  function teaPercup(cents, cups) {
    if (!cups) return '';
    return 'about ' + Math.round(cents / cups) + '\u00a2 a cup';
  }
  function set(id, fn) { var el = d.getElementById(id); if (el) fn(el); }

  function render() {
    var v = variant();
    var cups = cupsOf(v);
    var sub = v.sub || Math.round(v.price * 0.9);

    if (cfg.has_plans) {
      set('sub-price', function (el) { el.textContent = money(sub); });
      set('sub-strike', function (el) { el.textContent = money(v.price); });
      set('sub-percup', function (el) { el.textContent = cfg.is_coffee ? percup(sub, cups) : (cfg.is_tea ? teaPercup(sub, teaCupsOf(v)) : ''); });
      // real plan % per size (big bags run a lower % than 12oz)
      var pct = v.price > 0 ? Math.round(100 - (sub * 100 / v.price)) : 10;
      set('sub-pct', function (el) { el.textContent = pct; });
      set('sub-pct-how', function (el) { el.textContent = pct; });
      // 12oz and 2lb/5lb live in different selling plan groups, so the
      // frequency dropdown must carry THIS variant's plan ids or checkout 400s
      var freqSel = d.getElementById('freq');
      if (freqSel && v.plans && v.plans.length) {
        var current = String(state.planId || freqSel.value);
        var inList = v.plans.some(function (p) { return String(p.id) === current; });
        if (!inList) {
          var keepLabel = (freqSel.selectedOptions[0] || {}).textContent || '2 weeks';
          freqSel.innerHTML = v.plans.map(function (p) {
            var lab = p.opt.replace('Deliver every ', '');
            if (lab === 'week') lab = '1 week';
            return '<option value="' + p.id + '">' + lab + '</option>';
          }).join('');
          var match = [].slice.call(freqSel.options).filter(function (o) { return o.textContent === keepLabel; })[0];
          freqSel.value = match ? match.value : freqSel.options[Math.min(1, freqSel.options.length - 1)].value;
          state.planId = freqSel.value;
        }
      }
    }
    // subscription-only product whose plan group is not attached yet:
    // keep the server-rendered pending labels, only sync the sticky bar
    if (cfg.sub_only_pending) {
      set('bar-price', function (el) { el.textContent = money(sub); });
      set('bar-plan', function (el) { el.textContent = money(sub) + ' subscribed · subscriptions opening soon'; });
      return;
    }

    set('one-price', function (el) {
      el.innerHTML = v.compare_at > v.price
        ? money(v.price) + ' <s>' + money(v.compare_at) + '</s>'
        : money(v.price);
    });
    set('one-percup', function (el) { el.textContent = cfg.is_coffee ? percup(v.price, cups) : (cfg.is_tea ? teaPercup(v.price, teaCupsOf(v)) : ''); });

    var active = state.plan === 'sub' ? sub : v.price;

    // two-bag quick pick: qty comes from the hidden input the widget owns
    var qtyEl = d.getElementById('sq1-qty-input');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    set('tb-sub', function (el) {
      el.textContent = state.plan === 'sub'
        ? money(active) + ' per bag subscribed · subscribers always ship free'
        : money(active) + ' per bag · ' + money(active * 2) + ' for two';
    });

    set('cta', function (el) {
      el.textContent = (qty === 2 ? 'Add 2 Bags · ' : 'Add to Cart · ') + money(active * qty);
    });
    set('bar-price', function (el) { el.textContent = money(active); });
    set('bar-plan', function (el) {
      el.textContent = state.plan === 'sub'
        ? money(active) + ' with subscription'
        : (cfg.has_plans ? money(v.price) + ' one-time · ' + money(sub) + ' subscribed' : money(v.price));
    });

    // post-selection sub nudge: only when one-time is picked, savings computed per size
    set('one-nudge', function (el) {
      el.textContent = 'Subscribing saves you ' + money(v.price - sub) + ' a bag and ships free. Skip or cancel anytime.';
      el.hidden = !(cfg.has_plans && state.plan === 'one');
    });

    // receipt strip tracks the selected size
    set('receipt-strip', function (el) {
      // A product with its own detail line owns it; never overwrite on variant change.
      if (el.dataset.fixed) return;
      if (cfg.is_tea) {
        var tc = teaCupsOf(v);
        if (tc) el.innerHTML = (v.label === 'Default Title' ? tc + ' cups a pouch' : v.label + ' \u2248 ' + tc + ' cups') + ' \u00b7 whole leaf \u00b7 sealed fresh';
      } else if (cfg.is_coffee) {
        el.innerHTML = (v.label === 'Default Title' ? cups + ' cups a bag' : v.label + ' \u2248 ' + cups + ' cups') + ' \u00b7 roasted to order \u00b7 date on every bag';
      }
    });

    // form wiring: variant id + selling plan (disabled input is not submitted)
    set('sq1-variant-input', function (el) { el.value = state.variantId; });
    set('sq1-plan-input', function (el) {
      el.value = state.planId || '';
      el.disabled = state.plan !== 'sub' || !state.planId;
    });

    // discount strip only means something on the subscribe path
    set('auto-strip', function (el) { el.hidden = !(cfg.has_plans && state.plan === 'sub'); });

    // sub-aware cross-sell: chips only on the one-time path
    var isSub = state.plan === 'sub';
    [].forEach.call(d.querySelectorAll('.sq1-pdp .xsell-chip'), function (c) { c.hidden = isSub || !cfg.has_plans; });
  }

  window.sq1PickPlan = function (p) {
    if (!cfg.has_plans) return;
    state.plan = p;
    set('opt-sub', function (el) { el.classList.toggle('sel', p === 'sub'); });
    set('opt-one', function (el) { el.classList.toggle('sel', p === 'one'); });
    [].forEach.call(d.querySelectorAll('.sq1-pdp [data-plan-pick]'), function (el) {
      el.setAttribute('aria-pressed', el.dataset.planPick === p ? 'true' : 'false');
    });
    render();
  };
  // keyboard access for the plan option rows (role="button" divs)
  [].forEach.call(d.querySelectorAll('.sq1-pdp [data-plan-pick]'), function (el) {
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        window.sq1PickPlan(el.dataset.planPick);
      }
    });
  });
  window.sq1PickSize = function (btn) {
    state.variantId = parseInt(btn.dataset.variant, 10);
    [].forEach.call(d.querySelectorAll('.sq1-pdp .sizes button'), function (b) {
      b.classList.toggle('on', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    render();
  };

  // ATC submit: working state + double-submit guard (full-page POST to /cart/add)
  var pForm = d.getElementById('sq1-product-form');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      if (pForm.dataset.busy) { e.preventDefault(); return; }
      var cta = d.getElementById('cta');
      if (cta && cta.disabled) return;
      pForm.dataset.busy = '1';
      // defer the label swap a tick so the submit serializes untouched
      setTimeout(function () {
        if (cta) { cta.textContent = 'Adding to cart…'; cta.style.opacity = '.75'; }
      }, 0);
      // recover if navigation never happens (network drop)
      setTimeout(function () { delete pForm.dataset.busy; if (cta) cta.style.opacity = ''; render(); }, 10000);
      // grinding service: a ground grind adds the fee product first, then the form posts as usual.
      // If the fee call fails or stalls, the coffee still goes through: never lose the sale over $1.50.
      var grid = d.getElementById('grind');
      var gi = d.getElementById('sq1-grind-input');
      var feeVid = grid && grid.dataset.grindFeeVariant;
      if (feeVid && gi && gi.value !== 'Whole Bean' && !pForm.dataset.feeDone) {
        e.preventDefault();
        var qEl = d.getElementById('sq1-qty-input');
        var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
        var go = function () {
          if (pForm.dataset.feeDone) return;
          pForm.dataset.feeDone = '1';
          delete pForm.dataset.busy;
          if (pForm.requestSubmit) pForm.requestSubmit(); else pForm.submit();
        };
        setTimeout(go, 3000);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(feeVid, 10), quantity: qty, properties: { 'For': (grid.dataset.ptitle || 'coffee') + ' · ' + gi.value } })
        }).then(go, go);
      }
    });
    // back/forward-cache return: restore the CTA to a live state
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) {
        delete pForm.dataset.busy;
        var cta = d.getElementById('cta');
        if (cta) cta.style.opacity = '';
        render();
      }
    });
  }

  // two-bag quick pick toggle -> hidden quantity input
  var twobag = d.getElementById('twobag');
  if (twobag) {
    twobag.addEventListener('click', function () {
      var q = d.getElementById('sq1-qty-input');
      if (!q) return;
      var two = q.value !== '2';
      q.value = two ? '2' : '1';
      twobag.classList.toggle('on', two);
      twobag.setAttribute('aria-pressed', two ? 'true' : 'false');
      render();
    });
  }

  // frequency -> selling plan id
  var freq = d.getElementById('freq');
  if (freq) freq.addEventListener('change', function () { state.planId = freq.value; render(); });

  // grind chips -> line-item property (+ fee note when a ground option is picked)
  var grindInput = d.getElementById('sq1-grind-input');
  [].forEach.call(d.querySelectorAll('.sq1-pdp .grindgrid .sizebtn'), function (b) {
    b.addEventListener('click', function () {
      [].forEach.call(d.querySelectorAll('.sq1-pdp .grindgrid .sizebtn'), function (x) { x.classList.remove('sel'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('sel');
      b.setAttribute('aria-pressed', 'true');
      if (grindInput) grindInput.value = b.dataset.grind;
      var note = d.getElementById('gfee-note');
      if (note) note.hidden = b.dataset.grind === 'Whole Bean';
      var pf = d.getElementById('sq1-product-form');
      if (pf) delete pf.dataset.feeDone;
    });
  });

  // gallery swap (award sticker only on the first/bag shot)
  window.sq1SwapGal = function (btn) {
    var main = d.getElementById('gal-main');
    if (main) main.src = btn.dataset.src;
    [].forEach.call(d.querySelectorAll('.sq1-pdp .thumbs button'), function (b) {
      b.classList.toggle('on', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var sticker = d.getElementById('gal-sticker');
    if (sticker) sticker.style.display = btn.dataset.first === 'true' ? '' : 'none';
  };

  // sticky offer bar: desktop shows once the buy box has scrolled past;
  // mobile shows as soon as the user scrolls at all (price + CTA above the fold)
  var bb = d.getElementById('buybox');
  var bar = d.getElementById('offerbar');
  if (bb && bar) {
    var mobileMQ = window.matchMedia('(max-width:700px)');
    var pastBuybox = false;
    var syncOfferbar = function () {
      var show = mobileMQ.matches ? (window.scrollY > 100 || pastBuybox) : pastBuybox;
      bar.classList.toggle('on', show);
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      pastBuybox = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      syncOfferbar();
    }, { threshold: 0 }).observe(bb);
    window.addEventListener('scroll', syncOfferbar, { passive: true });
  }

  // cross-sell card gallery: swipe cycles the shots on touch, dots track position
  [].forEach.call(d.querySelectorAll('.pcard .swap[data-n]'), function (sw) {
    var imgs = [].slice.call(sw.querySelectorAll('.si'));
    var dots = [].slice.call(sw.querySelectorAll('.sdots i'));
    var idx = 0, sx = 0, sy = 0, swiped = false;
    sw.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    sw.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      idx = (idx + (dx < 0 ? 1 : imgs.length - 1)) % imgs.length;
      imgs.forEach(function (im, i) { im.classList.toggle('on', i === idx); });
      dots.forEach(function (dt, i) { dt.classList.toggle('on', i === idx); });
      swiped = true; setTimeout(function () { swiped = false; }, 400);
    }, { passive: true });
    sw.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopPropagation(); } });
  });

  render();
})();
